import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, BASE_URL } from "../../../../../utils/constants";
import { insertUpdateRentalAudioAndVideo_action, getRentalAudioAndVideoDetails_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/rentalAudioAndVideo_action/rentalAudioAndVideo_action'
import Modal from "react-modal";
import $ from 'jquery'
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDetails from "../../vendorDetails";

// 
class RentalAudioAndVedioEquipment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      isLoading: false,
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),
      tableList: [],
      agencyName: "",
      agencyEmail: "",
      exhibitorName: "",
      hallNo: "",
      stallNo: "",
      stallArea: "",
      stallType: "",
      openSides: "",
      Requirement: "",
      AgencyRentalAudioVideoID: "",
      contactDetailsList: [],
      url: "",
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false,
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)


    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addRentalAndVideoEquipment()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });

    const url = BASE_URL.split('/api')
    this.setState({ url: url[0] })

    this.getRentalAudioAndVideoDetails()
    this.loadscript()
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }


  handleCancel() {
    window.history.back()
  }

  inputValidate() {
    const { Is_Agree } = this.state

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({ Is_AgreeErr: 'kindly agree to disclaimer for rental audio and video equipments' })
    }
  }

  getRentalAudioAndVideoDetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state
    this.setState({ isLoading: true })
    this.props
      .getRentalAudioAndVideoDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          this.setState({
            contactDetailsList: data.AgencyDetails,
            exhibitorName: data.ExhibitorDetails[0]['CompanyName'],
            hallNo: data.ExhibitorDetails[0]['HallName'],
            stallNo: data.ExhibitorDetails[0]['StallName'],
            stallArea: data.ExhibitorDetails[0]['StallArea'],
            stallType: data.ExhibitorDetails[0]['StallTypeName'],
            openSides: data.ExhibitorDetails[0]['OpenSides'],
          })
          if (data.data != '') {
            this.setState({
              Remark: data.data[0]['Remark'],
              Is_Agree: data.data[0]['Is_Agree'],
              Requirement: data.data[0]['Comment'],
            })
          }
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addRentalAndVideoEquipment() {
    const { Remark, Is_Agree, AgencyRentalAudioVideoID, Requirement } = this.state
    this.inputValidate()
    this.setState({ isLoading: true })
    if (Is_Agree) {
      const ManualFormsID = this.props.location.state?.ManualFormsID || null;
      const ServiceID = this.props.location.state?.ServiceID || null;
      const VendorDetails = this.props.location.state?.VendorDetails || {};
      this.props
        .insertUpdateRentalAudioAndVideo_action(
          null,
          Remark,
          Is_Agree,
          ManualFormsID,
          ServiceID,
          VendorDetails
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess(
              this.state.StatusID == 0
                ? "Rental Audio And Video Form Submitted Successfully"
                : "Rental Audio And Video Form Updated Successfully"
            );
            setTimeout(() => {
              this.props.navigate("/manualForms");
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Plase Enter mandatory feilds!")
      this.inputValidate()
      this.setState({ isLoading: false })
    }
  }

  openImageInNextTab(path) {
    const { url } = this.state
    window.open(`${url}${path}#toolbar=0&navpanes=0`, '_blank');
  }

  render() {
    const { isLoading, isOpenConfirmationModal, Is_Agree, Remark, Is_AgreeErr, currentDate, DeadlineDate, tableList, Is_Agree2, is_View, isHideSection, Is_Agree2Err, agencyName, agencyEmail, exhibitorName, hallNo, stallNo, stallArea, stallType, openSides, Requirement, contactDetailsList, url, StatusID } = this.state
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="workUpdation-top-space">
              <div className="row mx-3">
                <div class="card rounded-0 p-0 shadow-none border">
                  <div class="card-header p-2">
                    <h3 class="card-title" >
                      Rental Audio And Video Equipment Form
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    <div style={{ lineHeight: "10px" }}>
                      <p>
                        1) Please send your remittance directly to official shell contractor.
                        Please do not send remittance to India ITME 2022.
                      </p>
                      <p>
                        2) Photos/Picture of the rental equipments wherever given are only for
                        demonstration & not actual.
                      </p>
                      <p>
                        3) Exhibitors are requested to contact their respective contractor for
                        technical specifications of the rental audio & Video equipments.
                      </p>
                    </div>
                    <VendorDetails />
                    {!isHideSection && (
                      <div className="row mt-4">
                        <h6 className="mt-2 ">
                          Water Connection{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}
                    <p className="m-0 mt-3 mb-2 fw-semibold">
                      Agency Contact Details:
                    </p>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {contactDetailsList != "" && contactDetailsList.length > 0 ? (
                        contactDetailsList.map((data) => (
                          <>
                            <div
                              class="table-responsive w-50"
                              style={{
                                backgroundColor: "#ebebeb",
                                marginBottom: "14px",
                                borderRight: "1px solid lightgray",
                              }}
                            >
                              <div
                                className="d-flex"
                                style={{
                                  margin: "10px 0 10px 10px",
                                  lineHeight: "23px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <p className="m-0">
                                    <strong>Name:</strong> {data.AgencyName}{" "}
                                  </p>
                                  <p className="m-0">
                                    <strong>Email:</strong> {data.AgencyEmail}
                                  </p>
                                </div>
                                {data.AgencyRentalAudioVideoImage != null ? (
                                  <div className="m-2">
                                    <iframe
                                      title="Passport Front Page"
                                      src={`${url}${data.AgencyRentalAudioVideoImage}#toolbar=0&navpanes=0`}
                                      // src='https://ems_uat.india-itme.com/document/Circular/10/Circular_10.pdf#toolbar=0&navpanes=0'
                                      style={{
                                        width: "220px",
                                        height: "250px",
                                        cursor: "pointer",
                                      }}
                                      id="myIframe"
                                    />
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "124px",
                                        width: "195px",
                                        height: "227px",
                                        cursor: "pointer",
                                        backgroundColor: "transparent",
                                      }}
                                      onClick={(e) =>
                                        this.openImageInNextTab(
                                          data.AgencyRentalAudioVideoImage
                                        )
                                      }
                                    />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </>
                        ))
                      ) : (
                        <div
                          class="table-responsive w-50"
                          style={{
                            backgroundColor: "#ebebeb",
                            marginBottom: "14px",
                            borderRight: "1px solid lightgray",
                          }}
                        >
                          <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                            <p className="m-0">No record found </p>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="p-1 bg-light text-left border">
                      <p className="m-0 fw-semibold">
                        Exhibitor Details:
                      </p>
                      <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                        <li>Exhibitor Name : {exhibitorName}</li>
                        <li>Hall No. : {hallNo}</li>
                        <li>Stall No. : {stallNo} </li>
                        <li>Stall Type: {stallType}</li>
                        <li>Area: {stallArea}</li>
                        <li>Sides open: {openSides}</li>
                      </ul>
                    </div>
                  </div>

                </div>

                <div class="card-body p-0 ">
                  <form>
                    <div className="">
                      {" "}
                      <label>Remark</label>{" "}

                      <textarea
                        class="form-control"
                        value={Remark}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        disabled={is_View || isDeadlinePassed}
                        maxLength={300}
                        rows="3"
                      ></textarea>
                    </div>
                    <label class="d-flex mt-2">
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={is_View || isDeadlinePassed}
                        onChange={(e) =>
                          this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                        }
                      />
                      I agree the above disclaimer for rental audio and video equipments
                      <span className="required">*</span>.
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    }
                  </form>
                </div>
                {/* <div class="row m-1"> */}
              </div>

              {!isHideSection && <div className="row">
                {currentDate > DeadlineDate && (
                  <span className="text-danger">
                    THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                  </span>
                )}
              </div>}
              <div className="row m-0">
                {!isHideSection && <div class="d-flex justify-content-end mt-0">
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                    style={{ marginRight: 10 }}
                    disabled={isDeadlinePassed}
                    // onClick={() => this.addRentalAndVideoEquipment()}
                    onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                  >
                    {this.state.StatusID == 0 ? "Submit" : "Update"}
                  </button>
                  <button
                    className="btn btn-gray rounded-1 d-block mt-3 mb-3"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(null, { insertUpdateRentalAudioAndVideo_action, getRentalAudioAndVideoDetails_action })(RentalAudioAndVedioEquipment));